import { CaptionAccentTypography } from '../../../components/atoms';

type NoDataBoxProps = React.PropsWithChildren<{
	description: string;
}>;

export const NoDataBox: React.FC<NoDataBoxProps> = ({ children, description }) => {
	return (
		<div className="flex flex-col items-center justify-center gap-[0.5rem]" data-testid="no-data-action">
			<CaptionAccentTypography className="text-secondary whitespace-pre-line text-center">
				{description}
			</CaptionAccentTypography>
			{children}
		</div>
	);
};
